import React, { useEffect } from "react";
import styled from "styled-components/macro";
import { useAuth } from "@src/contexts/AuthProvider";
import { getStorageLoginRedirect } from "@src/utils/session-storage";
import { useNavigate } from "react-router-dom";
import { Page } from "@src/shared/pages";

const ErrorDiv = styled.div`
  color: var(--error-color);
`;

const LoginWithToken: React.FC = () => {
  const { tokenUserData, error, vendorUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (tokenUserData || vendorUser) {
      navigate(
        getStorageLoginRedirect() ||
          (vendorUser ? Page.VENDOR_PORTAL_COMPANY_SELECTION : Page.HOME),
      );
    }
  }, [tokenUserData, navigate, vendorUser]);

  if (error) {
    return <ErrorDiv>{error}</ErrorDiv>;
  }

  return <div>Validating token...</div>;
};

export default LoginWithToken;
